<script>
  import { goto } from '$app/navigation';
  import Select, { Option } from '@smui/select';
  import { Graphic, Text } from '@smui/list';
  import ChannelIcon from '$lib/client/shared/channel-icon.svelte';
  import { channel, currentChannel } from '$lib/store';
  import { page } from '$app/stores';
  import { onMount } from 'svelte';

  export let channels = [];
  let toggleSlug = '';
  let userAction = false;

  $: {
    toggleSlug = $currentChannel?.slug || '';
    userAction = false;
  }
</script>

<Select
  class="channel-selector"
  variant="outlined"
  bind:value={toggleSlug}
  anchor$class="t-uppercase t-bold"
  menu$class="t-uppercase t-bold"
  on:click={() => (userAction = true)}
  on:SMUISelect:change={(e) => {
    if (userAction) {
      if ($channel && $channel.slug !== toggleSlug)
        channel.set(channels.find((c) => c.slug === toggleSlug) || $page.data.globalChannel);
      goto(`/music/${toggleSlug}`, { invalidateAll: true });
      userAction = false;
    }
  }}
>
  <ChannelIcon channel={$currentChannel} slot="leadingIcon" />
  {#each channels.filter((c) => c.live) as channel}
    <Option
      value={channel.slug}
      on:click={() => {
        if (channel.slug === $currentChannel?.slug) goto(`/music/${channel.slug || ''}`);
      }}
    >
      <Graphic>
        <ChannelIcon {channel} />
      </Graphic>
      <Text>
        <span>{channel.long_name || channel.short_name || channel.name}</span>
      </Text>
    </Option>
  {/each}
</Select>
